import type { Level } from "./types";

/**
 * Stars for a room given the prize banked in the cart:
 *   3 — matched the proven-best haul (the optimum)
 *   2 — banked at least 75% of it (the obvious greedy play lands here)
 *   1 — banked anything at all
 *   0 — banked nothing
 *
 * The optimum can never be beaten, so 3 stars is an exact tie with the solver.
 */
export function starsFor(level: Level, banked: number): number {
  if (banked <= 0) return 0;
  if (banked >= level.opt) return 3;
  if (banked >= level.opt * 0.75) return 2;
  return 1;
}
